/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Data_Storage_WeatherInputs */

const en_ui_data_storage_weather = /** @type {(inputs: Ui_Data_Storage_WeatherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weather`)
};

const de_ui_data_storage_weather = /** @type {(inputs: Ui_Data_Storage_WeatherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wetter`)
};

/**
* | output |
* | --- |
* | "Weather" |
*
* @param {Ui_Data_Storage_WeatherInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_data_storage_weather = /** @type {((inputs?: Ui_Data_Storage_WeatherInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Data_Storage_WeatherInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_data_storage_weather(inputs)
	return de_ui_data_storage_weather(inputs)
});